import BaseComponent from "../../../baseComponent.js";
import moment from "moment";
import "!style!css!../../../../vendors/tooltipster/tooltipster-3.3.0.css";
import styles from "./globe.scss";

// require("file?name=vendors/webgl-globe-alert.js!../../../../vendors/webgl-globe-alert.js");
// require("file?name=vendors/jquery.tooltipster-3.3.0.js!../../../../vendors/tooltipster/jquery.tooltipster-3.3.0.js");

export default class GlobeComponent extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // earthquake globe
    var container = document.getElementById('globe-container');
    var urls = {
      earth: '/resources/globe/blue-world-contrast.jpg',
      bump: '/resources/globe/bump.jpg'
    };

    this.loadGlobeAlert()
      .then(() => {
        this.globeController = new Globe.Alert(container, urls);
        this.globeController.init();

        // Bullet.on(EventType.Dashboard.TempEarthquakeGlobe.OCCURED, 'earthquake-globe.jsx>>onEarthquakeOccured', this.onEarthquakeOccured);
        // InternalEventBus.publish(InternalEvent.App.HIDE_PRELOADER);
        this.generateRandomEarthquakes();
      });
  }

  loadGlobeAlert() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../../../vendors/webgl-globe-alert.js');
          require('../../../../vendors/tooltipster/jquery.tooltipster-3.3.0.js');

          resolve();
        });
      }
      catch(err) {
        reject(err);
      }
    });
  }

  componentWillUnmount() {
    // Bullet.off(EventType.Dashboard.TempEarthquakeGlobe.OCCURED, 'earthquake-globe.jsx>>onEarthquakeOccured');
    this.dispose();
  }

  generateRandomEarthquakes() {
    var that = this;
    that.dataIndex = 0;

    setTimeout(() => {
      // Bullet.trigger(EventType.Dashboard.TempEarthquakeGlobe.OCCURED, getNextDataParam());
      this.onEarthquakeOccured(getNextDataParam());

      that.dataStreamInterval = setInterval(() => {
        this.onEarthquakeOccured(getNextDataParam());
      }, 10000);
    }, 3000);

    // inner functions
    function getNextDataParam() {
      // update data index
      that.dataIndex--;
      if (that.dataIndex === -1) {
        that.dataIndex = that.props.earthquakeData.length - 1;
      }

      var singleEarthquakeData = that.props.earthquakeData[that.dataIndex];

      var location = singleEarthquakeData[8];
      var commaIndex = location.indexOf(', ');
      var region, country;
      if (commaIndex > -1) {
        region = location.substring(0, commaIndex);
        country = location.substring(commaIndex + 2, location.length);
      }
      else {
        region = location;
        country = '';
      }

      var dateRaw = singleEarthquakeData[0];
      var date = moment(dateRaw).format("MMM d, YYYY");

      var param = {
        latitude: Number(singleEarthquakeData[2]),
        longitude: Number(singleEarthquakeData[3]),
        magnitude: Number(singleEarthquakeData[7]),
        region: region,
        country: country,
        date: date,
        time: singleEarthquakeData[1]
      }

      return param;
    }
  }

  onEarthquakeOccured(param) {
    var that = this;

    $('.earthquake-pulse-wrapper').remove();

    var pulseParams = fromRichterScale(param.magnitude);
    var $pulseWrapper, $pulse1, $pulse2, $pulse3;

    param.animationEnd = function () {
      if (!that.earthquakeOff) {
        $pulseWrapper = $('<div class="earthquake-pulse-wrapper"></div>');
        $pulseWrapper.width(pulseParams.size);
        $pulseWrapper.height(pulseParams.size);

        var contentHtml = '<div class="earthquake-tooltip">'
          + '<div class="magnitude">'
          + '<span style="color: ' + pulseParams.color + ';">' + param.magnitude + '</span> Magnitude'
          + '</div>'
          + param.region + '<br />';

        if (param.country !== "") {
          contentHtml += param.country + '<br />';
        }

        contentHtml += param.date + ' ' + param.time + ' UTC</div>';

        $pulseWrapper.tooltipster({
          position: 'bottom',
          ignoreMouse: true,
          content: $(contentHtml)
        });
        $('#globe-container').append($pulseWrapper);
        setTimeout(function () {
          $pulseWrapper.tooltipster('show');
        }, 500);

        $pulse1 = $('<div class="earthquake-pulse"></div>');
        $pulse1.width(pulseParams.size);
        $pulse1.height(pulseParams.size);
        $pulse1.css('border', '3px solid ' + pulseParams.color);

        $pulse2 = $('<div class="earthquake-pulse"></div>');
        $pulse2.width(pulseParams.size);
        $pulse2.height(pulseParams.size);
        $pulse2.css('border', '3px solid ' + pulseParams.color);

        $pulse3 = $('<div class="earthquake-pulse"></div>');
        $pulse3.width(pulseParams.size);
        $pulse3.height(pulseParams.size);
        $pulse3.css('border', '3px solid ' + pulseParams.color);

        $pulseWrapper.append($pulse1);
        setTimeout(function () {
          $pulseWrapper.append($pulse2);
        }, 200);
        setTimeout(function () {
          $pulseWrapper.append($pulse3);
        }, 400);
      }
    };

    this.globeController.earthquakeOccured(param);

    function fromRichterScale(magnitude) {
      // default
      var pulseParams = {
        size: 0,
        color: '#ffffff'
      };

      var sizeDelta = 4;
      var maxSize = 60;
      var scaledColorCodes = [
        '#FFFF00',
        '#FFE000',
        '#FFC000',
        '#FFA000',
        '#FF9000',
        '#FF7000',
        '#FF5000',
        '#FF3000',
        '#FF1000'
      ];
      var numScales = scaledColorCodes.length;

      for (var i = numScales; i >= 1; --i) {
        if (magnitude >= i) {
          pulseParams.size = maxSize - ((numScales - i) * sizeDelta);
          pulseParams.color = scaledColorCodes[i - 1];
          break;
        }
      }

      return pulseParams;
    }
  }

  onNavigationInitiated() {
    this.dispose();
  }

  dispose() {
    $('.tooltipster-base').css('display', 'none');

    this.earthquakeOff = true;
    clearInterval(this.dataStreamInterval);
    this.globeController.dispose();
  }

  render() {
    var style = {
      width: '100vw',
      height: 'calc(100vh - 100px)',
      position: 'relative'
    };

    return (
      <div id="globe-container" style={style}></div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/globe/earthquakes/globe.jsx